module.exports = __webpack_public_path__ + "img/gb.fcfef678.svg";